exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/_wks-ext.js
// module id = 140
// module chunks = 0 1